import React from 'react'
import { Button } from 'react-bootstrap'

import './styles.css'

const BtnNext = ({ text }) => (
    <Button className='btn-next' variant="primary" type="submit">
        { text }
    </Button>
)

export default BtnNext;